import Vue from 'vue'

import RbPlp from '@/elements/plp/rb-plp.vue'
Vue.component('rb-plp', RbPlp)

import RbPlpCrownModule from '@/elements/plp/crown-module/rb-crown-module.vue'
Vue.component('rb-crown-module', RbPlpCrownModule)

import RbCrosslink from '@/elements/plp/header/crosslinks/rb-crosslink.vue'
Vue.component('rb-crosslink', RbCrosslink)

import RbPromoStripe from '@/elements/plp/rb-plp-promo-stripe/rb-plp-promo-stripe.vue'
Vue.component('rb-plp-promo-stripe', RbPromoStripe)
